import templateUrl from './forgot-password.html';

export default {
  templateUrl,
  bindings: {
    userName: '<'
  },
  controller: class ForgotPasswordComponent {
    constructor($state, AuthService, ToastService) {
      'ngInject';

      Object.assign(this, { $state, AuthService, ToastService });
    }

    $onInit() {
    }

    onSubmit() {
      try {
        this.AuthService.forgotPassword(this.userName)
          .then(() => {
            this.$state.go('resetPasswordFromPin', { userName: this.userName });
          });
      } catch (e) {
        this.ToastService.showError();
      }
    }
  }
};



// WEBPACK FOOTER //
// ./components/auth/forgot-password/forgot-password.component.js